import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  ar: {
    welcome: {
      badge: "الجيل الجديد من الإدارة البيداغوجية",
      title: "منصة ",
      titleHighlight: "تمكين",
      subtitle: "بنية تحتية متطورة مصممة خصيصاً للمركز الوطني محمد السادس للمعاقين. تجمع بين مرونة الاستوديو التفاعلي وقوة التحليل البيداغوجي.",
      cta: "دخول المنصة",
      feature1Title: "تقييم تفاعلي مباشر",
      feature1Desc: "مبيانات خطية وتقارير تولد لحظياً لتتبع مسار المستفيد بدقة متناهية.",
      feature2Title: "سيادة رقمية",
      feature2Desc: "نظام مستقل بالكامل ومحمي، يضمن استقرار الأنشطة دون قيود خارجية.",
      feature3Title: "استوديو متقدم",
      feature3Desc: "واجهة بناء أنشطة بآلية السحب والإفلات تضاهي أقوى محررات الويب.",
      videoTitle: "تعرف على منصة تمكين"
    },
    login: {
      title: "منصة تمكين بلس",
      subtitle: "تسجيل الدخول للطاقم البيداغوجي والإدارة",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      submit: "تسجيل الدخول",
      forgot: "إذا نسيت بيانات الدخول، المرجو مراجعة الإدارة المركزية.",
      errorLocked: "هذا الحساب تم تجميده من قبل الإدارة المركزية.",
      errorInvalid: "البريد الإلكتروني أو كلمة المرور غير صحيحة."
    },
    admin: {
      sidebarRole: "الإدارة المركزية",
      tabUnits: "إدارة الوحدات",
      tabWorkshops: "إدارة الورشات",
      tabAccounts: "حسابات الأطر",
      logout: "تسجيل الخروج",
      headerTitle: "لوحة التحكم المركزية",
      headerSubtitle: "إدارة البنية التحتية والموارد البشرية للمركز",
      statUnits: "إجمالي الوحدات",
      statWorkshops: "الورشات النشطة",
      statEducators: "الأطر التربوية",
      addUnit: "إضافة وحدة جديدة",
      unitName: "اسم الوحدة",
      unitDesc: "وصف الوحدة",
      addWorkshop: "إنشاء ورشة",
      selectUnit: "اختر الوحدة",
      workshopName: "اسم الورشة",
      addAccount: "توليد حساب مؤطر",
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      assignWorkshop: "الورشة المعينة",
      status: "الحالة",
      active: "نشط",
      frozen: "مجمد",
      freeze: "تجميد",
      activate: "تفعيل",
      save: "حفظ البيانات",
      cancel: "إلغاء",
      edit: "تعديل",
      delete: "حذف",
      noData: "لا توجد بيانات مسجلة حالياً.",
      confirmDelete: "هل أنت متأكد من عملية الحذف؟ لا يمكن التراجع عن هذا الإجراء.",
      sidebar: {
        title: "الإدارة المركزية",
        subtitle: "سيادة رقمية مفعلة",
        tabOverview: "نظرة عامة والإنشاء",
        tabAccounts: "إدارة الحسابات والمرور",
        tabUnits: "الورشات والوحدات",
        tabLibrary: "مراقبة مكتبة الأنشطة",
        logout: "تسجيل الخروج"
      },
      header: {
        title: "مرحباً، الإدارة المركزية",
        subtitle: "نظرة شاملة على نشاط المنصة، الصلاحيات، والمحتوى."
      },
      stats: {
        totalEducators: "إجمالي المؤطرين",
        activeAccounts: "حسابات نشطة حالياً",
        registeredWorkshops: "الورشات المسجلة",
        distributedOn: "موزعة على",
        unitsWord: "وحدات",
        libraryActivities: "الأنشطة بالمكتبة",
        readyToUse: "جاهزة للاستخدام"
      },
      addEdu: {
        title: "توليد حساب مؤطر",
        warningNoWorkshop: "يجب إنشاء ورشات بيداغوجية أولاً قبل توليد حسابات الأطر.",
        fullName: "الاسم الكامل للمؤطر",
        namePlaceholder: "مثال: يونس الإدريسي...",
        workshopLabel: "الورشة المعين بها (بيانات حقيقية)",
        unspecified: "غير محدد",
        btnSubmit: "توليد الحساب بكلمة مرور قوية"
      },
      eduSummary: {
        title: "ملخص الطاقم البيداغوجي",
        editHint: "للتعديل الدقيق اذهب لـ 'إدارة الحسابات'",
        colName: "الاسم",
        colWorkshop: "الورشة التابع لها",
        colStatus: "الحالة",
        empty: "لا يوجد مؤطرين مسجلين بعد."
      },
      accountMgmt: {
        title: "إدارة الحسابات والصلاحيات",
        subtitle: "مراقبة الإيميلات المولدة، كلمات المرور، والتحكم الكلي في حسابات الأطر.",
        colEdu: "المؤطر (الاسم والورشة)",
        colLogin: "بيانات تسجيل الدخول (Email & Password)",
        colActions: "إجراءات الحساب",
        editBtn: "تعديل بيانات الحساب",
        deleteBtn: "حذف الحساب نهائياً",
        empty: "سجل الحسابات فارغ حالياً."
      },
      unitsWorkshops: {
        title: "إدارة الوحدات والورشات",
        subtitle: "تنظيم الهيكلة الإدارية للمركز (وحدات كبرى تتفرع منها ورشات).",
        addUnitBtn: "إضافة وحدة جديدة",
        unitManager: "مسؤول الوحدة:",
        affiliatedWorkshops: "ورشات تابعة",
        emptyUnits: "لا توجد أي وحدات بيداغوجية حالياً.",
        emptyUnitsHint: "قم بإضافة وحدة جديدة لتبدأ هيكلة المركز.",
        unitSpace: "مساحة إدارة الوحدة • المسؤول:",
        tabWorkshops: "الورشات التابعة",
        tabEducators: "الطاقم المؤطر للوحدة",
        addWorkshopBtn: "إنشاء ورشة جديدة في هذه الوحدة",
        workshopSettingsBtn: "إعدادات الورشة وتعديل الأطر",
        deleteWorkshopBtn: "حذف الورشة",
        assignedEducators: "مؤطرين معينين",
        emptyWorkshops: "لا توجد ورشات في هذه الوحدة بعد.",
        autoAssignedTitle: "الأطر المعينة في هذه الوحدة تلقائياً",
        colName: "الاسم",
        colEmail: "البريد الإلكتروني",
        colWorkshop: "الورشة التابع لها",
        colStatus: "الحالة",
        emptyEducators: "لا يوجد مؤطرون معينون في ورشات هذه الوحدة حتى الآن."
      },
      libraryMonitor: {
        title: "مراقبة المكتبة المشتركة",
        subtitle: "مراجعة المحتوى البيداغوجي وصلاحية الحذف.",
        designBy: "تصميم:",
        previewBtn: "معاينة",
        empty: "المكتبة المشتركة فارغة حالياً."
      },
      modals: {
        wsSettingsTitle: "إعدادات الورشة والأطر",
        wsName: "اسم الورشة",
        wsDesc: "وصف الورشة",
        wsStaffTitle: "أطر الورشة (تعديل الهوية)",
        currentEduName: "اسم المؤطر الحالي",
        emptyStaff: "لا يوجد أطر معينين في هذه الورشة حالياً.",
        nameChangeWarning: "ملاحظة: تغيير اسم المؤطر سيؤدي تلقائياً إلى توليد بريد وكلمة مرور جديدين له، مع الاحتفاظ بسجل أنشطته السابقة.",
        saveChangesBtn: "حفظ التعديلات",
        editLoginTitle: "تعديل بيانات الدخول",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        changePassHint: "قم بتغييرها هنا إذا فقد المؤطر إمكانية الدخول.",
        addUnitTitle: "إضافة وحدة جديدة",
        unitName: "اسم الوحدة",
        managerName: "اسم المسؤول",
        addUnitSubmit: "إضافة الوحدة",
        addWorkshopTitle: "إضافة ورشة للوحدة",
        addedUnder: "تضاف هذه الورشة تحت:",
        desc: "الوصف",
        approveWorkshopBtn: "اعتماد الورشة",
        previewTitle: "معاينة مرئية للنشاط",
        interactiveContent: "محتوى تفاعلي يحتوي على إعدادات متقدمة",
        interactionDisabled: "بدء التفاعل (معطل في المعاينة)"
      },
      alerts: {
        createWorkshopFirst: "السببية تقتضي إنشاء ورشة أولاً قبل تعيين المؤطرين! اذهب لتبويب 'الورشات والوحدات'.",
        enterNameAndWorkshop: "المرجو إدخال اسم المؤطر واختيار الورشة",
        accountGenerated: "تم توليد الحساب بنجاح!",
        alertEmail: "البريد:",
        alertPassword: "كلمة المرور القوية:",
        deleteAccountConfirm: "تحذير: هل أنت متأكد من حذف هذا الحساب نهائياً؟",
        deleteUnitConfirm: "حذف هذه الوحدة سيؤدي إلى مسح كل الورشات التابعة لها. هل أنت متأكد؟",
        deleteWorkshopConfirm: "هل أنت متأكد من حذف هذه الورشة؟",
        wsSettingsSavedGen: "تم تحديث إعدادات الورشة بنجاح.\nتم توليد بيانات دخول جديدة للأطر المتغيرين (مع الاحتفاظ بالسجل البيداغوجي للحساب):",
        wsSettingsSaved: "تم تحديث إعدادات الورشة بنجاح.",
        deleteActivityConfirm: "تحذير أمني: هل أنت متأكد من حذف هذا النشاط نهائياً من المكتبة المشتركة للمركز؟",
        newEduData: "\nالمؤطر الجديد:"
      }
    },
    educator: {
      defaultWorkshop: "الورشة البيداغوجية",
      defaultMentor: "مؤطر متخصص",
      sidebarRole: "مساحة المؤطر المتخصص",
      tabLibrary: "مكتبة الأنشطة",
      tabGroups: "إدارة المجموعات",
      tabBeneficiaries: "قائمة المستفيدين",
      tabEvaluations: "السجل البيداغوجي",
      logout: "تسجيل الخروج",
      headerTitles: {
        library: "الأنشطة التفاعلية",
        groups: "مجموعات العمل",
        beneficiaries: "المستفيدين",
        evaluations: "السجل البيداغوجي والتقارير"
      },
      headerSubtitle: "إدارة وتنفيذ العمليات البيداغوجية اليومية.",
      newActivityBtn: "تصميم نشاط جديد",
      library: {
        subtitle: "أطلق الأنشطة المصممة لتطبيقها على مجموعاتك.",
        noTemplate: "بدون قالب",
        applyBtn: "تطبيق",
        editBtn: "تعديل في الاستوديو",
        empty: "المكتبة فارغة. قم بتصميم نشاطك الأول."
      },
      groups: {
        subtitle: "قم بتنظيم المستفيدين في مجموعات متجانسة بيداغوجياً.",
        createBtn: "إنشاء مجموعة",
        membersCount: "مستفيدين في المجموعة",
        noMembers: "لا يوجد مستفيدون بعد.",
        empty: "لم تقم بإنشاء أي مجموعات بعد."
      },
      beneficiaries: {
        subtitle: "إدارة تفاصيل المستفيدين وتوزيعهم على المجموعات.",
        addBtn: "تسجيل مستفيد جديد",
        colName: "اسم المستفيد",
        colCondition: "الحالة / التشخيص",
        colGroup: "المجموعة",
        colActions: "الإدارة",
        unassigned: "غير معين",
        empty: "لا يوجد مستفيدون مسجلون."
      },
      evaluations: {
        emptyTitle: "السجل فارغ حالياً",
        emptySubtitle: "قم بتنفيذ الأنشطة وتقييم المستفيدين ليظهر السجل هنا.",
        progressTitle: "مسار التقدم البيداغوجي",
        week: "أسبوعي",
        month: "شهري",
        year: "سنوي",
        unknownBen: "غير معروف",
        noData: "لا توجد بيانات تقييم في هذا النطاق الزمني.",
        historyTitle: "السجل المفصل للجلسات",
        colDate: "التاريخ",
        colActivity: "النشاط المنجز",
        colGroup: "المجموعة",
        colScore: "متوسط التقييم",
        colActions: "إجراءات",
        detailsBtn: "التفاصيل"
      },
      modals: {
        editGroup: "تعديل المجموعة",
        newGroup: "إنشاء مجموعة جديدة",
        groupName: "اسم المجموعة",
        groupNamePlace: "مثال: مجموعة التحدي 1",
        saveGroup: "حفظ المجموعة",
        editBen: "تعديل بيانات المستفيد",
        newBen: "تسجيل مستفيد جديد",
        benName: "الاسم الكامل للمستفيد",
        benNamePlace: "مثال: يونس...",
        benCondition: "الحالة / نوع الإعاقة",
        benConditionPlace: "مثال: طيف التوحد، تأخر نمائي...",
        benGroup: "المجموعة التي سينتمي لها",
        selectGroup: "-- اختر مجموعة --",
        saveBen: "حفظ بيانات المستفيد",
        launchTitle: "تجهيز الجلسة",
        selectedActivity: "النشاط المختار:",
        noGroupsWarning: "لا يمكنك إطلاق النشاط لأنه لا توجد لديك مجموعات. قم بإنشاء مجموعة أولاً.",
        selectGroupLabel: "حدد المجموعة المستهدفة لتسجيل التقييمات:",
        confirmLaunch: "تأكيد وبدء التفاعل",
        evalDetailTitle: "تقرير مفصل للجلسة",
        responseLevel: "مستوى الاستجابة:",
        mentorNotes: "ملاحظات المؤطر:",
        noNotes: "لا توجد ملاحظات إضافية"
      },
      alerts: {
        deleteGroupConfirm: "هل أنت متأكد من حذف هذه المجموعة؟ سيتم فك ارتباط المستفيدين بها.",
        requireGroup: "يجب إنشاء مجموعة واحدة على الأقل قبل إضافة المستفيدين.",
        deleteBenConfirm: "حذف هذا المستفيد؟",
        emptyGroup: "هذه المجموعة فارغة!",
        deleteEvalConfirm: "حذف هذا السجل نهائياً؟"
      }
    }
  },
  fr: {
    welcome: {
      badge: "La nouvelle génération de gestion pédagogique",
      title: "Plateforme ",
      titleHighlight: "Tamkeen",
      subtitle: "Une infrastructure de pointe conçue spécifiquement pour le Centre National Mohammed VI des Handicapés. Elle allie la flexibilité d'un studio interactif à la puissance de l'analyse pédagogique.",
      cta: "Accéder à la plateforme",
      feature1Title: "Évaluation interactive",
      feature1Desc: "Graphiques linéaires et rapports générés instantanément pour suivre avec précision le parcours.",
      feature2Title: "Souveraineté numérique",
      feature2Desc: "Un système totalement indépendant et sécurisé, garantissant la stabilité des activités.",
      feature3Title: "Studio avancé",
      feature3Desc: "Une interface de création par glisser-déposer comparable aux meilleurs éditeurs web.",
      videoTitle: "Découvrez la Plateforme Tamkeen"
    },
    login: {
      title: "Plateforme Tamkeen Plus",
      subtitle: "Connexion pour l'équipe pédagogique et l'administration",
      email: "Adresse E-mail",
      password: "Mot de passe",
      submit: "Se connecter",
      forgot: "Si vous avez oublié vos identifiants, veuillez contacter l'administration centrale.",
      errorLocked: "Ce compte a été suspendu par l'administration centrale.",
      errorInvalid: "Adresse e-mail ou mot de passe incorrect."
    },
    admin: {
      sidebarRole: "Administration Centrale",
      tabUnits: "Gestion des Unités",
      tabWorkshops: "Gestion des Ateliers",
      tabAccounts: "Comptes Éducateurs",
      logout: "Se déconnecter",
      headerTitle: "Tableau de Bord Central",
      headerSubtitle: "Gestion de l'infrastructure et des ressources humaines",
      statUnits: "Total Unités",
      statWorkshops: "Ateliers Actifs",
      statEducators: "Éducateurs",
      addUnit: "Ajouter une Unité",
      unitName: "Nom de l'Unité",
      unitDesc: "Description",
      addWorkshop: "Créer un Atelier",
      selectUnit: "Sélectionner l'Unité",
      workshopName: "Nom de l'Atelier",
      addAccount: "Créer un Compte Éducateur",
      fullName: "Nom Complet",
      email: "Adresse E-mail",
      password: "Mot de passe",
      assignWorkshop: "Atelier Assigné",
      status: "Statut",
      active: "Actif",
      frozen: "Suspendu",
      freeze: "Suspendre",
      activate: "Activer",
      save: "Enregistrer",
      cancel: "Annuler",
      edit: "Modifier",
      delete: "Supprimer",
      noData: "Aucune donnée enregistrée pour le moment.",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ? Cette action est irréversible.",
      sidebar: {
        title: "Administration",
        subtitle: "Souveraineté numérique",
        tabOverview: "Aperçu et Création",
        tabAccounts: "Comptes et Accès",
        tabUnits: "Unités et Ateliers",
        tabLibrary: "Surveillance de la Bibliothèque",
        logout: "Se déconnecter"
      },
      header: {
        title: "Bonjour, Administration",
        subtitle: "Aperçu complet de l'activité, des permissions et du contenu."
      },
      stats: {
        totalEducators: "Total Éducateurs",
        activeAccounts: "Comptes actuellement actifs",
        registeredWorkshops: "Ateliers Enregistrés",
        distributedOn: "Répartis sur",
        unitsWord: "unités",
        libraryActivities: "Activités (Bibliothèque)",
        readyToUse: "Prêt à l'emploi"
      },
      addEdu: {
        title: "Générer un compte éducateur",
        warningNoWorkshop: "Veuillez créer des ateliers avant de générer des comptes éducateurs.",
        fullName: "Nom complet de l'éducateur",
        namePlaceholder: "Ex: Younes El Idrissi...",
        workshopLabel: "Atelier assigné (données réelles)",
        unspecified: "Non spécifié",
        btnSubmit: "Générer le compte (Mot de passe fort)"
      },
      eduSummary: {
        title: "Résumé de l'équipe",
        editHint: "Pour modifier, allez dans 'Comptes et Accès'",
        colName: "Nom",
        colWorkshop: "Atelier Affilié",
        colStatus: "Statut",
        empty: "Aucun éducateur enregistré pour le moment."
      },
      accountMgmt: {
        title: "Gestion des Comptes et Permissions",
        subtitle: "Gérer les emails générés, les mots de passe et le contrôle total des comptes.",
        colEdu: "Éducateur (Nom et Atelier)",
        colLogin: "Identifiants (Email & Mot de passe)",
        colActions: "Actions du compte",
        editBtn: "Modifier les données",
        deleteBtn: "Supprimer définitivement",
        empty: "Le journal des comptes est actuellement vide."
      },
      unitsWorkshops: {
        title: "Gestion des Unités et Ateliers",
        subtitle: "Organisation structurelle du centre (unités avec ateliers).",
        addUnitBtn: "Ajouter une Unité",
        unitManager: "Responsable:",
        affiliatedWorkshops: "Ateliers affiliés",
        emptyUnits: "Aucune unité pédagogique disponible.",
        emptyUnitsHint: "Ajoutez une nouvelle unité pour commencer à structurer le centre.",
        unitSpace: "Espace Unité • Responsable:",
        tabWorkshops: "Ateliers Affiliés",
        tabEducators: "Équipe de l'unité",
        addWorkshopBtn: "Créer un atelier dans cette unité",
        workshopSettingsBtn: "Paramètres de l'atelier",
        deleteWorkshopBtn: "Supprimer l'atelier",
        assignedEducators: "éducateurs assignés",
        emptyWorkshops: "Aucun atelier dans cette unité pour le moment.",
        autoAssignedTitle: "Éducateurs assignés automatiquement",
        colName: "Nom",
        colEmail: "Email",
        colWorkshop: "Atelier Affilié",
        colStatus: "Statut",
        emptyEducators: "Aucun éducateur assigné aux ateliers de cette unité."
      },
      libraryMonitor: {
        title: "Surveillance de la Bibliothèque",
        subtitle: "Vérifier le contenu pédagogique et l'autorité de suppression.",
        designBy: "Conçu par:",
        previewBtn: "Aperçu",
        empty: "La bibliothèque partagée est actuellement vide."
      },
      modals: {
        wsSettingsTitle: "Paramètres de l'Atelier",
        wsName: "Nom de l'atelier",
        wsDesc: "Description de l'atelier",
        wsStaffTitle: "Équipe de l'atelier (Modifier Identité)",
        currentEduName: "Nom actuel de l'éducateur",
        emptyStaff: "Aucun éducateur assigné à cet atelier.",
        nameChangeWarning: "Remarque: Modifier le nom générera un nouvel email et mot de passe, en conservant l'historique.",
        saveChangesBtn: "Enregistrer les modifications",
        editLoginTitle: "Modifier les Identifiants",
        email: "Adresse Email",
        password: "Mot de passe",
        changePassHint: "Modifiez-le ici si l'éducateur perd son accès.",
        addUnitTitle: "Ajouter une nouvelle Unité",
        unitName: "Nom de l'Unité",
        managerName: "Nom du Responsable",
        addUnitSubmit: "Ajouter l'Unité",
        addWorkshopTitle: "Ajouter un Atelier",
        addedUnder: "Ajouté sous:",
        desc: "Description",
        approveWorkshopBtn: "Approuver l'Atelier",
        previewTitle: "Aperçu Visuel de l'Activité",
        interactiveContent: "Contenu interactif avec paramètres avancés",
        interactionDisabled: "Démarrer l'interaction (Désactivé en aperçu)"
      },
      alerts: {
        createWorkshopFirst: "Vous devez créer un atelier avant d'assigner des éducateurs ! Allez dans 'Unités et Ateliers'.",
        enterNameAndWorkshop: "Veuillez saisir le nom de l'éducateur et sélectionner un atelier",
        accountGenerated: "Compte généré avec succès !",
        alertEmail: "Email:",
        alertPassword: "Mot de passe fort:",
        deleteAccountConfirm: "Attention: Êtes-vous sûr de vouloir supprimer ce compte définitivement ?",
        deleteUnitConfirm: "La suppression de cette unité effacera tous ses ateliers. Êtes-vous sûr ?",
        deleteWorkshopConfirm: "Êtes-vous sûr de vouloir supprimer cet atelier ?",
        wsSettingsSavedGen: "Paramètres de l'atelier mis à jour.\nDe nouveaux identifiants ont été générés (historique conservé) :",
        wsSettingsSaved: "Paramètres de l'atelier mis à jour avec succès.",
        deleteActivityConfirm: "Alerte de sécurité: Voulez-vous vraiment supprimer définitivement cette activité ?",
        newEduData: "\nNouvel Éducateur:"
      }
    },
    educator: {
      defaultWorkshop: "Atelier Pédagogique",
      defaultMentor: "Éducateur Spécialisé",
      sidebarRole: "Espace Éducateur",
      tabLibrary: "Bibliothèque d'Activités",
      tabGroups: "Gestion des Groupes",
      tabBeneficiaries: "Liste des Bénéficiaires",
      tabEvaluations: "Journal Pédagogique",
      logout: "Se déconnecter",
      headerTitles: {
        library: "Activités Interactives",
        groups: "Groupes de Travail",
        beneficiaries: "Bénéficiaires",
        evaluations: "Journal et Rapports"
      },
      headerSubtitle: "Gérer et exécuter les opérations pédagogiques quotidiennes.",
      newActivityBtn: "Concevoir une Activité",
      library: {
        subtitle: "Lancez les activités conçues pour vos groupes.",
        noTemplate: "Sans modèle",
        applyBtn: "Appliquer",
        editBtn: "Modifier (Studio)",
        empty: "La bibliothèque est vide. Créez votre première activité."
      },
      groups: {
        subtitle: "Organisez les bénéficiaires en groupes pédagogiques homogènes.",
        createBtn: "Créer un groupe",
        membersCount: "membres",
        noMembers: "Aucun bénéficiaire pour le moment.",
        empty: "Vous n'avez pas encore créé de groupes."
      },
      beneficiaries: {
        subtitle: "Gérer les détails des bénéficiaires et leur répartition.",
        addBtn: "Ajouter un bénéficiaire",
        colName: "Nom du Bénéficiaire",
        colCondition: "Condition / Diagnostic",
        colGroup: "Groupe",
        colActions: "Actions",
        unassigned: "Non assigné",
        empty: "Aucun bénéficiaire enregistré."
      },
      evaluations: {
        emptyTitle: "Le journal est actuellement vide",
        emptySubtitle: "Exécutez des activités et évaluez pour voir l'historique ici.",
        progressTitle: "Progrès Pédagogique",
        week: "Hebdomadaire",
        month: "Mensuel",
        year: "Annuel",
        unknownBen: "Inconnu",
        noData: "Aucune donnée d'évaluation dans cette période.",
        historyTitle: "Historique Détaillé des Sessions",
        colDate: "Date",
        colActivity: "Activité Réalisée",
        colGroup: "Groupe",
        colScore: "Score Moyen",
        colActions: "Actions",
        detailsBtn: "Détails"
      },
      modals: {
        editGroup: "Modifier le Groupe",
        newGroup: "Créer un Nouveau Groupe",
        groupName: "Nom du Groupe",
        groupNamePlace: "Ex: Groupe Défi 1",
        saveGroup: "Enregistrer le Groupe",
        editBen: "Modifier le Bénéficiaire",
        newBen: "Nouveau Bénéficiaire",
        benName: "Nom Complet",
        benNamePlace: "Ex: Younes...",
        benCondition: "Condition / Handicap",
        benConditionPlace: "Ex: Autisme, Retard global...",
        benGroup: "Groupe d'appartenance",
        selectGroup: "-- Sélectionner un groupe --",
        saveBen: "Enregistrer",
        launchTitle: "Préparation de la Session",
        selectedActivity: "Activité Sélectionnée :",
        noGroupsWarning: "Impossible de lancer l'activité car vous n'avez aucun groupe. Créez-en un d'abord.",
        selectGroupLabel: "Sélectionnez le groupe cible pour enregistrer l'évaluation :",
        confirmLaunch: "Confirmer et Démarrer",
        evalDetailTitle: "Rapport Détaillé de la Session",
        responseLevel: "Niveau de Réponse :",
        mentorNotes: "Notes de l'Éducateur :",
        noNotes: "Aucune note supplémentaire"
      },
      alerts: {
        deleteGroupConfirm: "Êtes-vous sûr de vouloir supprimer ce groupe ? Les bénéficiaires seront dissociés.",
        requireGroup: "Vous devez créer au moins un groupe avant d'ajouter des bénéficiaires.",
        deleteBenConfirm: "Supprimer ce bénéficiaire ?",
        emptyGroup: "Ce groupe est vide !",
        deleteEvalConfirm: "Supprimer cet enregistrement définitivement ?"
      }
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('tamkeen_lang') || 'ar');

  useEffect(() => {
    localStorage.setItem('tamkeen_lang', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (let k of keys) {
      if (value && value[k]) value = value[k];
      else return key; 
    }
    return value;
  };

  const toggleLanguage = () => setLanguage(prev => prev === 'ar' ? 'fr' : 'ar');

  return <LanguageContext.Provider value={{ language, toggleLanguage, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);